import { FilterDisplay } from "./filter-display.model";

export class ShoesFilterOptions {
    genders: FilterDisplay[];
    brands: FilterDisplay[];
    sizes: FilterDisplay[];
    widths: FilterDisplay[];
    priceRanges: FilterDisplay[];
    page: number;
    limit: number;

    constructor() {
        this.genders = [];
        this.brands = [];
        this.sizes = [];
        this.widths = [];
        this.priceRanges = [];
        this.page = 1;
        this.limit = 30;
    }

}
